import { staticText } from 'utils/staticText';

/** Privacy-policy links, same targets the reward consent copy uses. */
const PRIVACY_POLICY_EN =
  'https://www.moneyhero.com.hk/en/page/moneyhero-privacy-policy';
const PRIVACY_POLICY_ZH =
  'https://www.moneyhero.com.hk/zh/page/moneyhero-privacy-policy';

const privacyLink = (href: string, label: string) => (
  <a
    className="font-semibold text-text/link hover:underline"
    href={href}
    rel="noopener noreferrer"
    target="_blank"
  >
    {label}
  </a>
);

/**
 * Copy for the PL email-capture modal, verbatim from CMS-1818 §8.
 *
 * `_` carries the English wording (used for en-hk too); `zh-hk` is the primary
 * market language. `:provider` is interpolated with the lender's name.
 */
export const EmailCaptureStaticText = staticText({
  eyebrow: {
    _: 'BEFORE YOU GO TO :provider',
    'zh-hk': '前往 :provider 之前',
  },
  title: {
    _: 'Want to receive more loan options?',
    'zh-hk': '想收到更多貸款選擇？',
  },
  summaryLabel: {
    _: 'The loan product you selected',
    'zh-hk': '你揀選嘅貸款產品',
  },
  summaryLine: {
    _: ':amount · :tenure months · from :monthlyRepayment/month',
    'zh-hk': ':amount · :tenure 個月 · 每月還款低至 :monthlyRepayment',
  },
  summaryLineWithoutRepayment: {
    _: ':amount · :tenure months',
    'zh-hk': ':amount · :tenure 個月',
  },
  emailLabel: {
    _: 'Email address',
    'zh-hk': '電郵地址',
  },
  emailPlaceholder: {
    _: 'name@example.com',
    'zh-hk': 'name@example.com',
  },
  consentAriaLabel: {
    _: 'Marketing consent',
    'zh-hk': '營銷同意',
  },
  consentError: {
    _: 'Please tick the box above to agree before continuing.',
    'zh-hk': '請先剔選上方方格表示同意，然後繼續。',
  },
  submit: {
    _: 'Send my email & continue to :provider',
    'zh-hk': '寄出電郵並前往 :provider',
  },
  skip: {
    _: 'No thanks, continue without email',
    'zh-hk': '唔使喇，直接前往',
  },
  assurance: {
    _: "It won't affect your application. Takes about 5 seconds.",
    'zh-hk': '唔會影響你嘅申請，大約只需 5 秒',
  },
  confirmation: {
    _: "You're all set. Taking you to :provider…",
    'zh-hk': '一切就緒，正帶你前往 :provider…',
  },
});

/**
 * The consent sentence, kept apart from the strings above because it carries a
 * Privacy Policy link — `tr()` only interpolates plain strings.
 */
export const EmailCaptureConsentText = staticText({
  consent: {
    _: (
      <>
        I agree that MoneyHero may use the email I provide on this page,
        together with the loan product I selected on MoneyHero, processed in
        accordance with the {privacyLink(PRIVACY_POLICY_EN, 'Privacy Policy')},
        to send me personalised recommendations and marketing about other
        personal loan products or services. I understand this consent is
        voluntary and I can unsubscribe anytime.
      </>
    ),
    'zh-hk': (
      <>
        我同意 MoneyHero 使用我在本頁提供的電郵，以及我於 MoneyHero
        選擇的貸款產品，按{privacyLink(PRIVACY_POLICY_ZH, '私隱政策')}
        處理，並就其他私人貸款產品或服務向我發送個人化建議及市場推廣資訊。我明白此同意屬自願，並可隨時取消訂閱。
      </>
    ),
  },
});
